import { useTranslation } from "react-i18next";
import { Badge } from "@/atoms/badge";
import { StoreButtons } from "@/components/store-buttons";

/**
 * The old checkout's success return.
 *
 * The receipt shape without the figures, because this page never learns them: Stripe's hosted
 * checkout took the payment and sends the person back with nothing in the URL. So it says what
 * happened, what to do next, and offers the two ways to get Gymkee, as text.
 *
 * The green disc with a tick is gone, and so are the store badge images.
 */

export function Checkoutv1SuccessPage() {
  const { t } = useTranslation();

  return (
    <div className="bg-surface-paperSoft px-gk-4 py-gk-8 flex min-h-screen flex-col items-center justify-center">
      <div className="ds-reveal sm:bg-surface-paper ds-hairline sm:rounded-card sm:p-gk-6 gap-gk-6 flex w-full max-w-[520px] flex-col sm:border">
        <div className="gap-gk-4 flex flex-col items-start">
          <Badge tone="success">{t("gymkeePay.common.statusPaid")}</Badge>
          <h1 className="text-[32px] leading-[1.15] font-semibold text-[var(--gk-text-primary)]">
            {t("gymkeePay.receipt.headline")}
          </h1>
          <p className="text-[15px] leading-[1.55] text-[var(--gk-text-secondary)]">
            {t("gymkeePay.receipt.v1SuccessLine")}
          </p>
        </div>
        <StoreButtons />
      </div>
    </div>
  );
}
